<script>
import { required, minLength } from 'vuelidate/lib/validators';
import Repositories from '@/repositories';
const AllocationGroups = Repositories.get('allocationgroups');
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';

/**
 * Dashboard Component
 */
export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      isError: false,
      allocationGroupForm: {
        name: null,
      },
    };
  },
  methods: {
    submitAllocationGroup() {
      this.$v.allocationGroupForm.$touch();
      if (!this.$v.allocationGroupForm.$invalid) {
        this.isLoading = true;
        this.createAllocationGroup();
      }
    },
    createAllocationGroup() {
      this.isError = false;

      let queryModel = {
        idPublic: null,
        name: this.allocationGroupForm.name,
      };

      AllocationGroups.create(queryModel)
        .then((response) => {
          let resAllocationGroup = response.data;

          this.allocationGroupForm.name = null;
          this.$v.$reset();
          this.$emit('allocation-group-added', resAllocationGroup);
          this.isLoading = false;
        })
        .catch(() => {
          //RAISEE
          this.isLoading = false;
          this.isError = true;
        });
    },
  },
  validations: {
    allocationGroupForm: {
      name: { required, minLength: minLength(3) },
    },
  },
};
</script>

<template>
  <b-container fluid>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>
    <b-row>
      <b-col sm="12" xl="3">
        <b-form-group
          :label="$t('general.name')"
          label-for="allocation-group-name-input"
        >
          <b-form-input
            id="allocation-group-name-input"
            :class="{
              'is-invalid': $v.allocationGroupForm.name.$error,
            }"
            @keydown.enter.prevent="submitAllocationGroup"
            v-model="allocationGroupForm.name"
            :placeholder="$t('general.name')"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="12" xl="2" class="flex-vertical-align-bottom">
        <div style="margin-bottom: 18px">
          <b-button
            @click="submitAllocationGroup"
            block
            variant="primary"
            :disabled="isLoading"
          >
            <i
              v-if="isLoading"
              class="bx bx-loader-alt bx-spin"
              style="font-size: 1.2em"
            >
            </i>
            <i
              v-else-if="isError"
              class="fas fa-exclamation text-danger"
              style="margin-left: 4px; margin-right: 4px"
            ></i>
            <span v-else>{{ $t('general.add') }}</span>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
